module.exports = __webpack_public_path__ + "img/workspace-onboarding/add-to-team-library-164b00a721bff1a7e661572b93bb3b28.png";